import { gql } from "@apollo/client";

import { VENUE_USER_WITH_RELATIONS_FRAGMENT } from "./fragments/venueUserWithRelations";
import { VENUE_USER_FRAGMENT } from "./fragments/venueUser";

export const VENUE_USER_READ_QUERY = gql`
  ${VENUE_USER_WITH_RELATIONS_FRAGMENT}
  query VenueUserRead(
    $id: Int!
    $venueInclude: Boolean!
    $userInclude: Boolean!
  ) {
    venueUser(id: $id) {
      ...VenueUserWithRelations
    }
  }
`;

export const VENUE_USER_LIST_QUERY = gql`
  ${VENUE_USER_FRAGMENT}
  query VenueUserList(
    $take: Int
    $skip: Int
    $filters: VenueUserFilterInput
    $orderBy: [VenueUserOrderByInput!]
  ) {
    venueUsers(take: $take, skip: $skip, filters: $filters, orderBy: $orderBy) {
      count
      nodes {
        ...VenueUser
      }
    }
  }
`;
